import React, { useEffect, useState } from 'react'
import AttendanceDaysShowCard from '../../../Components/AttendanceDaysShowCard'
import Table from '../../../Components/Table'
import { useLocation } from 'react-router-dom';
import qs from "query-string";
import moment from 'moment';
import workingDaysIcon from '../../../Assets/Images/Attendance/working-days.svg';
import dayPresentIcon from '../../../Assets/Images/Attendance/day-present.svg';
import lateCalanderIcon from '../../../Assets/Images/Attendance/late-calander.svg';
import halfDayCalanderIcon from '../../../Assets/Images/Attendance/half-day-calander.svg';
import absentCalanderIcon from '../../../Assets/Images/Attendance/absent-calander.svg';
import holidayCalanderIcon from '../../../Assets/Images/Attendance/holiday-calander.svg';

const header = [
  { field: "Date" },
  { field: "Status" },
  { field: "Clock In" },
  { field: "Clock Out" },
  { field: "Total" },
  { field: "Others" },
];

function EmpAttendanceByMember(props) {
  const [viewChange, setViewChange] = useState("Table");
  const [inData, setInData] = useState([]);
  const [checked, setChecked] = useState(false);
  const [exportLoading, setExportrLoading] = useState(false);
  const [totalSelectedIds, setTotalSelectedIds] = useState([]);
  const [params, setParams] = useState({});
  const [selectedId, setSelectedId] = useState([]);
  const month = new Date().getMonth() + 1;
  const year = new Date().getFullYear();
  const [workingDays, setWorkingDays] = useState(0);
  const [daysPresent, setDaysPresent] = useState(0);
  const [late, setLate] = useState(0);
  const [halfDay, setHalfDay] = useState(0);
  const [absent, setAbsent] = useState(0);
  const [holiday, setHoliday] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState(month);
  const [selectedYear, setSelectedYear] = useState(year);

  const location = useLocation();
  let footer = true;
  let count = inData?.length;

  const calculateDaysInMonth = (month, year) => {
    return new Date(year, month, 0).getDate();
  };

  const calculateTotalHours = (clockIn, clockOut) => {
    const inTime = moment(clockIn, 'HH:mm:ss');
    const outTime = moment(clockOut, 'HH:mm:ss');
    const duration = moment.duration(outTime.diff(inTime));

    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();

    return `${hours}h ${minutes}m`;
  };

  const getTotalHours = (punch) => {
    if (!punch?.clock_in) return "-";

    if (punch.clock_out) {
      return calculateTotalHours(punch.clock_in, punch.clock_out);
    }

    if (moment(punch.date).isSame(moment(), 'day')) {
      return calculateTotalHours(punch.clock_in, moment());
    }

    return calculateTotalHours(punch.clock_in, moment(punch.date, 'HH:mm:ss').endOf('day'));
  };

  useEffect(() => {
    if (!props?.data?.user || !props?.data?.attendance || !props?.data?.leave) {

      return
    };

    (async () => {
      try {
        setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));

        const userId = props?.data?.user?.id;
        const attendanceData = props?.selectedUser ? props?.data?.attendance?.filter(att => att?.employee_id == props?.selectedUser?.id) : props?.data?.attendance?.length > 0 ? props?.data?.attendance?.filter(att => att?.employee_id == props?.data?.user?.id) : [];
        const leaveData = props?.data?.leave?.filter(item => item?.employee_id === userId) || [];

        const currentDate = moment();
        const selectedMonthValue = props?.selectFilters?.Month?.value !== "May" && props?.selectFilters?.Month?.value;
        const selectedYearValue = props?.selectFilters?.Year?.value;

        let tempMonth = selectedMonthValue
          ? new Date(`${selectedMonthValue} 1, ${selectedYearValue || currentDate.year()}`).getMonth() + 1
          : currentDate.month() + 1;

        let tempYear = selectedYearValue ? parseInt(selectedYearValue) : currentDate.year();

        setSelectedMonth(tempMonth);
        setSelectedYear(tempYear);

        const selectedDate = moment(`${tempYear}-${tempMonth}-01`, 'YYYY-MM-DD');
        const firstDayOfNextMonth = moment().startOf('month').add(1, 'month');

        if (selectedDate.isSameOrAfter(firstDayOfNextMonth)) {
          setInData([]);
          setWorkingDays(0);
          setDaysPresent(0);
          setLate(0);
          setHalfDay(0);
          setHoliday(0);
          setAbsent(0);
          return;
        }

        const daysInThisMonth = calculateDaysInMonth(tempMonth, tempYear);

        let workingDaysCount = 0;
        let daysPresentCount = 0;
        let lateCount = 0;
        let halfDayCount = 0;
        let holidayCount = 0;
        let absentCount = 0;

        let tableData = [];

        for (let i = 1; i <= daysInThisMonth; i++) {
          const date = moment(`${tempYear}-${tempMonth}-${i}`, 'YYYY-M-D');
          if (date.format('ddd') !== 'Sun') workingDaysCount += 1;
        }

        setWorkingDays(workingDaysCount);

        const isCurrentMonth = tempMonth === currentDate.month() + 1 && tempYear === currentDate.year();
        const isFilterApplied = props?.selectFilters?.Late?.value || (props?.selectFilters?.Month?.value !== "May" && props?.selectFilters?.Month?.value) || props?.selectFilters?.Year?.value;
        const todayDate = (isCurrentMonth && !isFilterApplied) ? currentDate.date() : daysInThisMonth;

        for (let i = todayDate; i >= 1; i--) {
          const date = moment(`${tempYear}-${tempMonth}-${i}`, 'YYYY-M-D');
          const formattedDate = date.format('YYYY-MM-DD');

          const attendanceRecords = attendanceData.filter(a => moment(a.date).format('YYYY-MM-DD') === formattedDate);
          let earliestPunch = null;
          let latestPunch = null;
          let totalWorkMinutes = 0;
          let isLate = false;
          const leave = leaveData.find(l => moment(l.start_date).format('YYYY-MM-DD') === formattedDate && l.status === 'Approved');

          let status = "Absent";
          let punch = earliestPunch;
          let late = isLate;

          if (attendanceRecords.length > 0) {
            const sorted = attendanceRecords
              .filter(a => a.clock_in)
              .sort((a, b) => moment(a.clock_in, 'HH:mm:ss') - moment(b.clock_in, 'HH:mm:ss'));

            earliestPunch = sorted[0];
            latestPunch = sorted[sorted.length - 1];

            const firstIn = moment(earliestPunch?.clock_in, 'HH:mm:ss');
            const lateTime = moment('11:00', 'HH:mm');
            if (firstIn.isAfter(lateTime)) {
              isLate = true;
              lateCount++
            }

            attendanceRecords.forEach(p => {
              const inTime = moment(p.clock_in, 'HH:mm:ss');
              const outTime = p.clock_out ? moment(p.clock_out, 'HH:mm:ss') : moment();
              if (outTime && outTime.isAfter(inTime)) {
                totalWorkMinutes += outTime.diff(inTime, 'minutes');
              }
            });
          }

          if (attendanceRecords.length > 0) {
            status = 'Present';
            daysPresentCount++;
          } else if (leave) {
            if ((leave?.firstHalf && !leave?.secondHalf) || (!leave?.firstHalf && leave?.secondHalf)) {
              status = 'Half Day';
              halfDayCount++;
            } else {
              status = '';
            }
          } else if (date.format('ddd') === 'Sun') {
            status = "Holiday";
            holidayCount++;
          } else {
            status = "Absent";
            absentCount++;
          }
          const hours = Math.floor(totalWorkMinutes / 60);
          const minutes = totalWorkMinutes % 60;
          const totalFormatted = `${hours}:${minutes.toString().padStart(2, '0')}`;

          tableData.push({
            "Date": {
              value: formattedDate,
              value2: date.format("dddd"),
              type: "date"
            },
            "Status": {
              value: status,
              value2: (leave?.firstHalf || leave?.secondHalf || status === '') && 'On Leave',
              type: "attandancestatus"
            },
            // "Clock In": {
            //   value: earliestPunch?.clock_in ? [{
            //     clockIn: moment(earliestPunch.clock_in, 'HH:mm:ss').format('hh:mm A'),
            //     location: 'Ahmedabad',
            //     workType: 'Office'
            //   }] : [],
            //   type: "clockin"
            // },
            // "Clock Out": {
            //   value: latestPunch?.clock_out ? [{
            //     clockOut: moment(latestPunch.clock_out, 'HH:mm:ss').format('hh:mm A'),
            //     location: 'Ahmedabad',
            //     workType: 'Office'
            //   }] : [{
            //     clockIn: '-',
            //     clockOut: '-',
            //     location: '',
            //     workType: ''
            //   }],
            //   type: "clockout"
            // },
            "Clock In": {
              value: attendanceRecords?.map(record => {
                const inTime = record?.clock_in ? moment(record?.clock_in, 'HH:mm:ss') : null;
                const isLate = inTime && inTime.isAfter(moment('11:00', 'HH:mm'));

                return {
                  clockIn: record.clock_in ? moment(record.clock_in, 'HH:mm:ss').format('hh:mm A') : '-',
                  lateValue: isLate && 'Late',
                  location: record.city || 'N/A',
                }
              }),
              type: "clockin"
            },
            "Clock Out": {
              value: attendanceRecords?.map(record => ({
                clockOut: record.clock_out ? moment(record.clock_out, 'HH:mm:ss').format('hh:mm A') : '-',
                location: 'Ahmedabad',
                workType: 'Office'
              })),
              type: "clockout"
            },

            "Total": {
              value: attendanceRecords?.length > 0 ? totalFormatted : '',
              type: "text"
            },
            "Others": {
              value2: "/attendance/empdetails",
              type: "action"
            },
            dayDetails: {
              date: formattedDate,
              records: attendanceData.filter(att => moment(att.date).format('YYYY-MM-DD') === formattedDate)
            }
          });
        }

        if (props?.selectFilters?.Late?.value) {
          tableData = tableData?.filter((item) =>
            item?.Status?.value == props?.selectFilters?.Late?.value ||
            item?.Status?.value2 == props?.selectFilters?.Late?.value
          )
        }
        tableData.sort((a, b) => moment(b["Date"].value).diff(moment(a["Date"].value)));
        setInData(tableData);
        setDaysPresent(daysPresentCount);
        setLate(lateCount);
        setHalfDay(halfDayCount);
        setHoliday(daysInThisMonth - workingDaysCount);
        setAbsent(absentCount);
      } catch (error) {
        console.error("Error building attendance table:", error);
      }
    })();
  }, [
    location?.search,
    props
  ]);

  const handleChange = (e) => {
    if (e[1] == "headerAll" && e[0] === true) {
      setTotalSelectedIds([...e[2]]);
    } else if (e[0] === true && e[1] !== "headerAll") {
      setTotalSelectedIds([...totalSelectedIds, e[1]]);
    } else if (e[1] == "headerAll" && e[0] === false) {
      setTotalSelectedIds([]);
    } else {
      let filterdId = totalSelectedIds.filter((item) => {
        return item != e[1];
      });
      setTotalSelectedIds(filterdId);
    }
  };

  const handleClick = async (totalSelectedIds, type) => {
    let ids = totalSelectedIds.map((id) => parseFloat(id));

    try {
      if (type === "delete") {
        setDeleteLoading(true);
        await props.deleteInvoices(ids);
        setChecked(false);
        setTotalSelectedIds([]);
      } else if (type === "export") {
        setExportrLoading(true);
        await handlePdfDownload(ids);
        toast.success("Exported Successfully");
      }
    } catch (error) {
      console.error(error);
    } finally {
      await fetchData();
      setDeleteLoading(false);
    }
  };

  useEffect(() => {
    if (totalSelectedIds.length > 0) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [totalSelectedIds]);

  return (
    <div>
      <div className='row'>
        <div className="col-lg-2 col-md-4 col-sm-6 col-xs-12">
          <AttendanceDaysShowCard title="Working Days" qty={workingDays} img={workingDaysIcon} />
        </div>
        <div className="col-lg-2 col-md-4 col-sm-6 col-xs-12">
          <AttendanceDaysShowCard title="Days Present" qty={daysPresent} img={dayPresentIcon} />
        </div>
        <div className="col-lg-2 col-md-4 col-sm-6 col-xs-12">
          <AttendanceDaysShowCard title='Late' qty={late} img={lateCalanderIcon} />
        </div>
        <div className="col-lg-2 col-md-4 col-sm-6 col-xs-12">
          <AttendanceDaysShowCard title="Half Days" qty={halfDay} img={halfDayCalanderIcon} />
        </div>
        <div className="col-lg-2 col-md-4 col-sm-6 col-xs-12">
          <AttendanceDaysShowCard title="Absent" qty={absent} img={absentCalanderIcon} />
        </div>
        <div className="col-lg-2 col-md-4 col-sm-6 col-xs-12">
          <AttendanceDaysShowCard title="Holiday" qty={holiday} img={holidayCalanderIcon} />
        </div>
        <div className="col-md-12 mb-5">
          <Table
            header={header}
            data={inData}
            footer={footer}
            count={count}
            checked={checked}
            records={1}
            showIsView={true}
            handleChange={handleChange}
            totalSelectedIds={totalSelectedIds}
            defaultParams={params}
            selectedId={selectedId}
            totalRecordsToShow={inData?.length}
            loading={props.loading}
          />

        </div>
      </div>
    </div>
  )
}

export default EmpAttendanceByMember;